import { useEffect, useRef, useState } from "react";
import { FFA_BOOKMARKLET } from "@/lib/ffaImport";
import { toast } from "sonner";
import { Bookmark, Copy } from "lucide-react";

export const FfaHelp = () => {
  const ref = useRef(null);
  const [steps] = useState([
    "Installez une seule fois le bouton : faites glisser « Envoyer à l'affiche » ci-dessous dans votre barre de favoris (ou copiez le code et créez un favori avec ce code comme adresse).",
    "Ouvrez la page de votre club sur ffa.be (ex. ffa.be/club/6165/matches-a-venir).",
    "Cliquez sur le favori « Envoyer à l'affiche », choisissez les dates : les matchs sont copiés.",
    "Revenez ici, collez (Ctrl+V) dans la zone ci-dessous et cliquez sur « Importer les matchs et logos ».",
  ]);
  useEffect(() => { ref.current?.setAttribute("href", FFA_BOOKMARKLET); }, []);
  const copy = async () => {
    try { await navigator.clipboard.writeText(FFA_BOOKMARKLET); toast.success("Code du favori copié"); }
    catch { toast.error("Copie impossible"); }
  };
  return (
    <div className="space-y-2 rounded-lg border border-border bg-secondary/40 p-3 text-xs" data-testid="ffa-help">
      <ol className="list-decimal space-y-1 pl-4 text-muted-foreground">
        {steps.map((s) => <li key={s}>{s}</li>)}
      </ol>
      <div className="flex flex-wrap items-center gap-2 pt-1">
        <a ref={ref} onClick={(e) => { e.preventDefault(); toast.info("Faites glisser ce bouton dans votre barre de favoris"); }}
          className="inline-flex cursor-grab items-center gap-1 rounded-md bg-primary px-3 py-1.5 font-semibold text-primary-foreground"
          data-testid="ffa-bookmarklet-link">
          <Bookmark className="h-3.5 w-3.5" /> Envoyer à l'affiche
        </a>
        <button onClick={copy} className="inline-flex items-center gap-1 text-muted-foreground underline-offset-2 hover:underline" data-testid="ffa-copy-code">
          <Copy className="h-3 w-3" /> Copier le code du favori
        </button>
      </div>
    </div>
  );
};
